const moduleName = 'langDropdown';

export function langDropdown() {

		const el = document.querySelector('.js-lang-dropdown');

		if ( !el ) return;

    el.addEventListener('click', e => {
			const target = e.currentTarget;
			const container = target.closest('.js-lang-dropdown');
			const menu = container.querySelector('.js-lang-dropdown-menu');

			container.classList.toggle('_open')
		})

		window.addEventListener("click", function(e) {
			const target = e.target;
			el.classList.contains("_open") && !e.target.closest(".js-lang-dropdown") && el.classList.remove("_open")
		})
}